<template>
    <YearPickerNext
        v-bind="forwardedProps"
        :as="DsIconButton"
        icon="fa-solid fa-chevron-right"
        size="xs"
        tooltipText="Next years"
    />
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import { reactiveOmit } from '@vueuse/core';
import type { YearPickerNextProps } from 'reka-ui';
import { YearPickerNext, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<YearPickerNextProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
